import React from 'react'
import { LoadingStyled } from './styles'

const Loading = () => {
  return (
    <LoadingStyled className='loading' />
  )
}

export default Loading
